/*! Lazy Image */
class LazyImage extends HTMLImageElement {
  constructor() {
    super();

    this.wrapper = this.closest('.media-wrapper');
    if (this.wrapper === null) return;

    // Hills: Nur das erste Bild einer Kachel steuert den Ladezustand der Hülle.
    // Sonst hält ein abgebrochenes Hover-Bild die ganze Kachel unsichtbar.
    this.isPrimary = this.wrapper.querySelector('img[is="lazy-image"]') === this;

    this.handleLazy();
    addEventListener('resize', this.handleLazy.bind(this), true);

    const observer = new MutationObserver((changes) => {
      changes.forEach((change) => {
        if (change.attributeName.includes('src') || change.attributeName.includes('srcset')) {
          this.handleLazy();
        }
      });
    });
    observer.observe(this, {attributes : true});
  }

  handleLazy () {
    const mql = window.matchMedia('(min-width: 750px)');
    if (mql.matches && this.classList.contains('medium-hide')) return;
    if (!mql.matches && this.classList.contains('small-hide')) return;
    if (this.classList.contains('loaded')) return;
    // Hills: bereits fertig geladene (gecachte) Bilder sofort als geladen markieren — sonst bleibt .image-animate unsichtbar
    const done = () => {
      this.classList.add('loaded');
      if (this.isPrimary) this.wrapper.classList.remove('loading');
    };

    if (this.complete) {
      done();
      return;
    }

    if (this.isPrimary) this.wrapper.classList.add('loading');

    this.addEventListener('load', () => {
      window.requestIdleCallback ? window.requestIdleCallback(done, {timeout: 150}) : setTimeout(done);
    }, false);

    // Hills: Fehlgeschlagene oder abgebrochene Bilder dürfen die Kachel nicht blockieren
    this.addEventListener('error', done, false);
    setTimeout(done, 3000);
  }
}
window.customElements.define('lazy-image', LazyImage, { extends: 'img' });

class ProgPicture extends HTMLPictureElement {
  constructor() {
    super();

    this.abortController = new AbortController();
    this.addEventListener('touchmove', this.touchmove_handler, { signal: this.abortController.signal });
  }

  touchmove_handler(ev) {
    if (ev.scale > 1) {
      var hqImage = this.getAttribute('data-hq');
      this.querySelector('source').setAttribute('srcset', hqImage);
      this.abortController.abort();
    }
  }
}
window.customElements.define('prog-picture', ProgPicture, { extends: 'picture' });